const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 38 38",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6300_15658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6300_15658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.944 18.4336C20.6177 17.7008 21.1161 16.8594 21.4391 15.9094C21.7618 14.9594 21.9232 13.98 21.9232 12.9711C21.9232 11.9623 21.7618 10.9828 21.4391 10.0328C21.1161 9.08284 20.6177 8.24143 19.944 7.50861C21.3344 7.66905 22.489 8.2694 23.4076 9.30965C24.3259 10.3502 24.7851 11.5707 24.7851 12.9711C24.7851 14.3718 24.3259 15.5923 23.4076 16.6326C22.489 17.6728 21.3344 18.2732 19.944 18.4336ZM28.2565 30.5707V26.8558C28.2565 25.9926 28.0809 25.1714 27.7297 24.3921C27.3784 23.6128 26.8801 22.9441 26.2346 22.386C27.4485 22.79 28.5659 23.3351 29.5869 24.0212C30.6079 24.7073 31.1184 25.6522 31.1184 26.8558V30.5707H28.2565ZM31.1184 20.1875V17.0209H27.9517V14.6459H31.1184V11.4792H33.4934V14.6459H36.6601V17.0209H33.4934V20.1875H31.1184ZM13.2148 18.5128C11.6909 18.5128 10.3862 17.9702 9.30084 16.8851C8.21573 15.7997 7.67318 14.4951 7.67318 12.9711C7.67318 11.4472 8.21573 10.1426 9.30084 9.05751C10.3862 7.97213 11.6909 7.42944 13.2148 7.42944C14.7388 7.42944 16.0433 7.97213 17.1284 9.05751C18.2138 10.1426 18.7565 11.4472 18.7565 12.9711C18.7565 14.4951 18.2138 15.7997 17.1284 16.8851C16.0433 17.9702 14.7388 18.5128 13.2148 18.5128ZM1.33984 30.5707V27.0505C1.33984 26.2752 1.55043 25.5572 1.97159 24.8964C2.39276 24.2356 2.9555 23.7276 3.65982 23.3724C5.22495 22.6053 6.80379 22.0299 8.39636 21.6462C9.98867 21.2625 11.5948 21.0707 13.2148 21.0707C14.8346 21.0707 16.4408 21.2625 18.0333 21.6462C19.6256 22.0299 21.2043 22.6053 22.7695 23.3724C23.4738 23.7276 24.0365 24.2356 24.4577 24.8964C24.8791 25.5572 25.0898 26.2752 25.0898 27.0505V30.5707H1.33984Z",
    style: {
      fill: "color(display-p3 0.3765 0.3725 0.3804)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupPlus);
export default __webpack_public_path__ + "static/media/GroupPlus.7d4b1cf6f373fce2b4db24b845d3d3c7.svg";
export { ForwardRef as ReactComponent };